
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f788Q", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $513b3aabfa44d17f$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $jpi63 = parcelRequire("jpi63");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-4a86e52c9f";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $513b3aabfa44d17f$var$BASE_URL = "https://www.atlassian.com";
const $513b3aabfa44d17f$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $513b3aabfa44d17f$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $k2OeR.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const page = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "canonical",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "alternate",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $513b3aabfa44d17f$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $loA2J.jsx)("link", {
                        rel: "alternate",
                        href: `${$513b3aabfa44d17f$var$BASE_URL}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jpi63.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("6KSFr", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryPage", function () { return $35f571ea04e8eac4$export$d8efa57f95a0eae9; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $4LHd8 = parcelRequire("4LHd8");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");
parcelRequire("aRHrH");
var $9O2F2 = parcelRequire("9O2F2");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("hDgra");
var $iBOlP = parcelRequire("iBOlP");
const $35f571ea04e8eac4$export$d8efa57f95a0eae9 = ()=>{
    const intl = (0, $f6qj2.default)();
    const isBootIntercom = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp1304AddIntercomToJpdProductTour);
    (0, $iSvIT.useEffect)(()=>{
        (0, $4LHd8.default).getLayer("wac-edge-track-routing-layer").get("track", "main");
    }, []);
    const intercomAppId = intl.locale === "ja" ? "p0ww63i2" : "";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O2F2.IntercomProvider), {
        appId: intercomAppId,
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3LLDq.CrossFlowTouchpointProvider), {
            screenName: "wacJpdProductTourPage",
            productKeys: [
                (0, $i8kxh.ProductKeys).JIRA_PRODUCT_DISCOVERY
            ],
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iBOlP.JiraProductDiscoveryTemplate), {})
        })
    });
};

});
parcelRegister("aRHrH", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return (parcelRequire("9O2F2")).IntercomProvider; });
parcelRequire("9O2F2");
parcelRequire("42XIn");

});
parcelRegister("9O2F2", function(module, exports) {

$parcel$export(module.exports, "IntercomProvider", function () { return $be094a112486886f$export$5091c5023e5c7eba; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $l4i0P = parcelRequire("l4i0P");

var $gkhN4 = parcelRequire("gkhN4");

var $7OS3I = parcelRequire("7OS3I");
const $be094a112486886f$var$isWindowExist = typeof window !== "undefined";
const $be094a112486886f$export$e578ca56db818a8e = /*#__PURE__*/ $iSvIT.createContext(undefined);
const $be094a112486886f$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $iSvIT.useRef(false);
    const isInit = $iSvIT.useRef(false);
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const initIntercomInstance = $iSvIT.useCallback(()=>{
        if (!isInit.current) {
            (0, $7OS3I.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $iSvIT.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === "complete") // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener("DOMContentLoaded", handleLoad);
                    window.removeEventListener("load", handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener("DOMContentLoaded", handleLoad);
                window.addEventListener("load", handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error("Intercom: DOM ready timeout reached, proceeding anyway");
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $iSvIT.useCallback(async ()=>{
        if ($be094a112486886f$var$isWindowExist && isInit.current && !isBooted.current) {
            var _window_intercomSettings;
            const intercomSettings = (_window_intercomSettings = window.intercomSettings) !== null && _window_intercomSettings !== void 0 ? _window_intercomSettings : {
                app_id: appId
            };
            try {
                var _window_Intercom, _window, _window_Intercom1, _window1;
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "boot", (0, $7Knp0._)({
                    alignment: "right",
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: "#intercomLauncher"
                }, intercomSettings));
                (_window_Intercom1 = (_window1 = window).Intercom) === null || _window_Intercom1 === void 0 ? void 0 : _window_Intercom1.call(_window1, "trackEvent", "widget-loaded");
            } catch (error) {
                console.warn("Intercom boot failed:", error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $iSvIT.useCallback(()=>{
        if (!isBooted.current) return;
        if ($be094a112486886f$var$isWindowExist) {
            var _window_Intercom, _window;
            (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "shutdown");
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $iSvIT.useCallback(()=>{
        var _window_Intercom, _window;
        if ($be094a112486886f$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "show");
    }, []);
    const hide = $iSvIT.useCallback(()=>{
        var _window_Intercom, _window;
        if ($be094a112486886f$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "hide");
    }, []);
    $iSvIT.useEffect(()=>{
        if ($be094a112486886f$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $l4i0P.default).get("ajs_anonymous_id") || "";
            if (anonId) intercomSettingsObj["anonymousId"] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj["name"] = getwayApiMeGetResponse.name;
                intercomSettingsObj["email"] = getwayApiMeGetResponse.email;
            }
            if ($be094a112486886f$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $iSvIT.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($be094a112486886f$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $be094a112486886f$export$28418e623d2470bc = ()=>{
    const context = $iSvIT.useContext($be094a112486886f$export$e578ca56db818a8e);
    if (context === undefined) throw new Error("This hook must be used within IntercomProvider");
    return context;
};

});
parcelRegister("7OS3I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f03bd135604494e$export$2e2bcd8739ae039; });
function $9f03bd135604494e$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, "attachEvent");
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $9f03bd135604494e$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            var _x_parentNode;
            const s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/" + appId;
            const x = d.getElementsByTagName("script")[0];
            x === null || x === void 0 ? void 0 : (_x_parentNode = x.parentNode) === null || _x_parentNode === void 0 ? void 0 : _x_parentNode.insertBefore(s, x);
        };
        if (document.readyState === "complete") l();
        else if ($9f03bd135604494e$var$isIELikeWindow(w)) w.attachEvent("onload", l);
        else w.addEventListener("load", l, false);
    }
};
var $9f03bd135604494e$export$2e2bcd8739ae039 = $9f03bd135604494e$var$initializeIntercomInstance;

});


parcelRegister("42XIn", function(module, exports) {
// Intercom Types & Interface ===========================================================
// all the Interface stuff from: https://developers.intercom.com/installing-intercom/web/attributes-objects/

});


parcelRegister("hDgra", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryTemplate", function () { return (parcelRequire("iBOlP")).JiraProductDiscoveryTemplate; });
parcelRequire("iBOlP");

});
parcelRegister("iBOlP", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryTemplate", function () { return $36eb65e9a86c668a$export$55460b563be26bbf; });

var $loA2J = parcelRequire("loA2J");

var $4XrxY = parcelRequire("4XrxY");

var $kex29 = parcelRequire("kex29");

var $4CuE6 = parcelRequire("4CuE6");

var $j6Axx = parcelRequire("j6Axx");

var $ksmCY = parcelRequire("ksmCY");

var $5twbI = parcelRequire("5twbI");

var $h0v1e = parcelRequire("h0v1e");

var $bWsik = parcelRequire("bWsik");

var $2m2Kl = parcelRequire("2m2Kl");

var $fnNPE = parcelRequire("fnNPE");

var $bvUhK = parcelRequire("bvUhK");

var $iGwIR = parcelRequire("iGwIR");

var $9GfN9 = parcelRequire("9GfN9");

var $8E2OI = parcelRequire("8E2OI");
const $36eb65e9a86c668a$export$55460b563be26bbf = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $j6Axx.default), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("main", {
                    id: "content",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $4CuE6.JPDBanner), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $fnNPE.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $9GfN9.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $bWsik.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $2m2Kl.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $iGwIR.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $ksmCY.AtlassianIntelligence), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $bvUhK.HowItWorks), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $8E2OI.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5twbI.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $h0v1e.default), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("4CuE6", function(module, exports) {

$parcel$export(module.exports, "JPDBanner", function () { return $382e43584557f81d$export$637e7e5d1efd26e9; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("fovuc");
var $5ZfUA = parcelRequire("5ZfUA");

var $3FBn4 = parcelRequire("3FBn4");

var $gAJUc = parcelRequire("gAJUc");
const $382e43584557f81d$export$637e7e5d1efd26e9 = ()=>{
    const intl = (0, $f6qj2.default)();
    const gwp6473JpdPremiumBanner = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp6473JpdPremiumBanner);
    const gwp7456JpdStateOfProductBanner = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7456JpdStateOfProductBanner);
    const gwp8038JpdBannerWebinar = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp8038JpdBannerWebinar);
    const gwp9038JdpAIWebinarBanner = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp9038JdpAIWebinarBanner);
    const jpdBannerMessagesWebinar = {
        identifier: "JPDPageTemplate.webinar-announcement",
        text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JPDPageTemplate.banner-alert.state-of-product-webinar-announcement",
            defaultMessage: "<strong>State of Product 2026:</strong> Register for the webinar to hear the surprising findings!",
            values: (0, $3FBn4.DEFAULT_VALUES)
        }),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.state-of-product-webinar-announcement.link-text",
            defaultMessage: "Register now \u2192"
        }),
        linkUrl: (0, $3FBn4.useLocalizedHref)("/webinars/software/state-of-product-2026"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Register now",
            "data-label-english": "Register now",
            "data-track-event": "jpdPageTemplate.bannerAlert.stateOfProductWebinarAnnouncement.registerNow"
        }
    };
    const jpdBannerMessagesStateOfProduct = {
        identifier: "JPDPageTemplate.premium-announcement",
        text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JPDPageTemplate.banner-alert.state-of-product-announcement",
            defaultMessage: "<strong>State of Product 2026:</strong> Find out what 1000+ product teams think in our newest research report.",
            values: (0, $3FBn4.DEFAULT_VALUES)
        }),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.state-of-product-announcement.link-text",
            defaultMessage: "Read now \u2192"
        }),
        linkUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/resources/state-of-product-2026"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Read now",
            "data-label-english": "Read now",
            "data-track-event": "jpdPageTemplate.bannerAlert.stateOfProductAnnouncement.readNow"
        }
    };
    const jpdBannerMessagesAIWebinar = {
        identifier: "JPDPageTemplate.ai-webinar-annnouncement",
        text: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.ai-webinar-annnouncement",
            defaultMessage: "AI product strategy: How to build & win today."
        }),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.link-text",
            defaultMessage: "Get the Details \u2192"
        }),
        linkUrl: (0, $3FBn4.useLocalizedHref)("/webinars/software/jira-product-discovery-ai-webinar"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Get the Details",
            "data-label-english": "Get the Details",
            "data-track-event": "jpdPageTemplate.announcementBanner.learnMore"
        }
    };
    const jpdBannerMessagesPremium = {
        identifier: "JPDPageTemplate.premium-announcement",
        text: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.premium-announcement",
            defaultMessage: "Jira Product Discovery Premium is now available! Get more visibility, control, and support to build products at scale."
        }),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.link-text",
            defaultMessage: "Learn more \u2192"
        }),
        linkUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/premium"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more",
            "data-track-event": "jpdPageTemplate.announcementBanner.learnMore"
        }
    };
    if (gwp9038JdpAIWebinarBanner) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), (0, $7Knp0._)({}, jpdBannerMessagesAIWebinar));
    if (gwp8038JpdBannerWebinar) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), (0, $7Knp0._)({}, jpdBannerMessagesWebinar));
    if (gwp7456JpdStateOfProductBanner) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), (0, $7Knp0._)({}, jpdBannerMessagesStateOfProduct));
    if (gwp6473JpdPremiumBanner) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), (0, $7Knp0._)({}, jpdBannerMessagesPremium));
    return null;
};

});
parcelRegister("fovuc", function(module, exports) {

$parcel$export(module.exports, "BannerAlert", function () { return (parcelRequire("5ZfUA")).BannerAlert; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("5ZfUA")).BannerAlert; });

var $5ZfUA = parcelRequire("5ZfUA");

});
parcelRegister("5ZfUA", function(module, exports) {

$parcel$export(module.exports, "BannerAlert", function () { return $a7a242474da496d8$export$4eb8f3e4e539379b; });
/* banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");

var $1syhO = parcelRequire("1syhO");
const $a7a242474da496d8$var$containerStyles = null;
const $a7a242474da496d8$var$contentStyles = null;
const $a7a242474da496d8$var$closeIconStyles = null; /**
                               * @deprecated - Please use @/libraries/design/components/banner-alert instead
                               */ 
const $a7a242474da496d8$export$4eb8f3e4e539379b = ({ identifier: identifier, text: text, linkText: linkText, linkUrl: linkUrl, dataEventProps: dataEventProps, hasProductNavBar: hasProductNavBar })=>{
    const intl = (0, $f6qj2.default)();
    const bannerStorageItem = `BannerAlert_dismiss-${identifier}`;
    const translatedLabel = intl.formatMessage({
        id: "banner-alert.close.aria-label",
        defaultMessage: "Close"
    });
    const [isHidden, setIsHidden] = (0, $iSvIT.useState)(true);
    (0, $iSvIT.useEffect)(()=>{
        let dismissValue = null;
        dismissValue = (0, $1syhO.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    const dynamicStyles = hasProductNavBar ? {
        marginBlockStart: "60px"
    } : {};
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "banner-alert",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-dismissed": isHidden ? "true" : undefined,
            className: (0, $esG4f.default)([
                "_bfhkuzct _kqswh2mm _y4ti1ejb _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1pbykb7n _nzmgglyw"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                    "aria-label": translatedLabel,
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $1syhO.setLocalStorage)(bannerStorageItem, "1");
                    },
                    className: (0, $esG4f.default)([
                        "_r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _rjxp1ul9 _152tpxbi _1nj119tk"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Cross), {
                        size: "20"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    style: dynamicStyles,
                    className: (0, $esG4f.default)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozgxy5q _y4tixncg _1e0c11p5 _syaz1mpp _1a9ox7w3 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _1d61glyw _14l354rc"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                children: text
                            }),
                            "\xa0",
                            linkText && linkUrl && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                text: linkText,
                                href: linkUrl,
                                type: "inline",
                                dataEventProps: dataEventProps
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});



parcelRegister("j6Axx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c253c89c6f96043e$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");
const $c253c89c6f96043e$var$JpdLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV2), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    });
};
const $c253c89c6f96043e$var$JiraProductDiscoveryNavV2 = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const links = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                // this id can be renamed once the above has been fixed as well
                id: "jiraproductdiscovery.navbar.product-features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/features")
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                // this id should be renamed, but for Team'24 hotfix we need to keep existing mapping
                id: "jiraproductdiscovery.navbar.features",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/pricing")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "jiraproductdiscovery.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/resources")
        }
    ];
    // TODO: this duplicates the value from the v1 product nav
    // this was to use an accurate existing translation for a Team'24 hot fix
    const ctaText = intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
        productLogoUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery"),
        productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($c253c89c6f96043e$var$JpdLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "wacJiraProductDiscoveryNavigation.logo-label",
            defaultMessage: "Jira Product Discovery logo"
        }),
        mobileCtaText: ctaText,
        mobileCtaUrl: signupLink,
        mobileCtaOnClick: openCrossFlow,
        mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($c253c89c6f96043e$var$JpdLogo, {}),
        navigationTrynowCtaText: ctaText,
        navigationTrynowCtaUrl: signupLink,
        navigationTrynowCtaOnClick: openCrossFlow,
        productPageNavLinks: links,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-jira-product-discovery",
                mobileLinksProps: links
            }
        ]
    });
};
$c253c89c6f96043e$var$JiraProductDiscoveryNavV2.displayName = "JiraProductDiscoveryNavV2";
var $c253c89c6f96043e$export$2e2bcd8739ae039 = $c253c89c6f96043e$var$JiraProductDiscoveryNavV2;

});

parcelRegister("ksmCY", function(module, exports) {

$parcel$export(module.exports, "AtlassianIntelligence", function () { return $28812ae5faf1418d$export$eec9700d5a261698; });
/* ai.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $28812ae5faf1418d$var$ArrowPencilPointRight = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        style: {
            color: props.color ? props.color : "currentColor",
            transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`
        },
        width: "50",
        height: "17",
        viewBox: "0 0 72 25",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $esG4f.default)([
            "_tnrurdoj _1rfm1tcg _1vkhl52n _12rr12am"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fill: "currentColor",
            d: "M59.938 15.4c-.92-.48-1.816-.597-2.7-.75a7.975 7.975 0 0 0-2.872.044c-.848.163-1.709.062-2.511-.19-1.5-.473-3.039-.55-4.597-.555-.973-.005-1.959-.054-2.916-.202-.663-.104-1.292-.416-1.965-.642-.392.625-.992.599-1.612.367-1.278-.481-2.594-.57-3.947-.543-.736.014-1.463-.158-2.068-.635-.077-.056-.175-.084-.267-.117-.61.602-1.323.564-2.063.397-1.19-.262-2.387-.5-3.577-.762-.804-.18-1.606-.377-2.409-.569-.797-.196-1.56-.48-2.43-.276-1.08.253-2.16-.009-3.235-.18-1.226-.2-2.439-.518-3.666-.604-2.097-.152-4.158-.522-6.235-.81-.993-.14-1.991-.243-2.975-.423a42.808 42.808 0 0 1-2.978-.664c-1.046-.264-2.085-.582-3.121-.882C1.122 7.214.74 6.67.444 6.112.36 5.953.59 5.534.78 5.337c.594-.621 1.35-.92 2.211-.987 1.934-.153 3.86-.06 5.774.12 1.72.162 3.425.459 5.124.761 1.963.342 3.938.566 5.928.725 1.551.12 3.096.346 4.645.495 1.447.144 2.9.241 4.353.38 1.607.156 3.215.305 4.824.502 2.28.273 4.55.593 6.831.872 1.62.199 3.241.391 4.895.293.938-.058 1.897.126 2.828.295 1.34.24 2.692.28 4.046.348 1.651.082 3.303.158 4.96.246.474.026.944.098 1.42.124.13.013.267-.05.401-.072-.052-.126-.069-.295-.162-.37-.553-.454-1.127-.874-1.68-1.327-1.467-1.208-2.934-2.416-4.394-3.635-.563-.473-.885-1.124-1.227-1.76-.208-.387-.023-.71.165-1.002.18-.28.301-.676.723-.71.29-.024.579-.048.87-.041 1.45.024 2.74.566 4.009 1.184.906.442 1.796.925 2.718 1.344.386.178.62.43.782.807.114.264.204.591.615.274.182-.137.404-.09.571.125.246.314.537.602.782.921.167.222.358.277.63.3 1.026.064 1.83.574 2.406 1.407.371.537.868.9 1.432 1.15.655.29 1.24.663 1.702 1.185.85.958 1.653 1.953 2.45 2.954.341.43.245 1.248-.147 1.657-.703.737-1.431 1.44-2.117 2.191-.368.406-.66.885-1 1.323-.14.178-.285.415-.478.478-.75.258-1.239.837-1.802 1.342-.233.21-.48.442-.76.557-.915.379-1.838.732-2.774 1.043-.273.091-.606-.027-.91-.023-.139.004-.345.03-.402.12-.507.805-1.262 1.2-2.163 1.25-1.377.08-2.673.52-4.003.82-1.53.344-3.061.683-4.589 1.052a13.66 13.66 0 0 1-3.57.36c-.512-.011-.884-.266-1.065-.674-.39-.899-.488-.879.139-1.69.118-.155.253-.297.35-.466.372-.67 1.031-.793 1.682-1.007 1.115-.364 2.208-.796 3.296-1.234 1.425-.578 2.831-1.193 4.246-1.784.764-.322 1.542-.601 2.29-.949.75-.348 1.47-.753 2.287-1.178l.016-.034z"
        })
    });
};
const $28812ae5faf1418d$var$ArrowPencilPointLeft = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        style: {
            color: props.color ? props.color : "currentColor",
            transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`
        },
        width: "50",
        height: "17",
        viewBox: "0 0 72 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $esG4f.default)([
            "_tnrurdoj _1rfm1tcg _1vkhl52n _12rr12am"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fill: "currentColor",
            d: "M11.923 9.891c.933.429 1.83.508 2.72.622a8.268 8.268 0 0 0 2.87-.149c.843-.189 1.706-.123 2.515.09 1.513.401 3.053.417 4.61.365.973-.031 1.96-.021 2.921.086.666.076 1.303.353 1.983.546.374-.617.975-.614 1.6-.413 1.292.416 2.61.453 3.962.376.735-.04 1.467.098 2.084.536.08.051.178.075.271.104.594-.604 1.307-.594 2.051-.46 1.197.208 2.4.393 3.597.601.809.144 1.616.304 2.424.46.802.16 1.572.404 2.437.176 1.072-.285 2.16-.072 3.24.053 1.23.147 2.452.409 3.68.446 2.102.069 4.172.35 6.256.55.997.097 1.998.16 2.986.297 1.006.139 2.007.323 2.995.53 1.053.216 2.101.484 3.145.735.677.158 1.073.668 1.385 1.196.088.15-.132.564-.316.76-.577.622-1.325.94-2.184 1.035-1.93.22-3.856.202-5.776.099-1.724-.091-3.436-.315-5.143-.543a66.397 66.397 0 0 0-5.946-.479c-1.554-.057-3.105-.218-4.657-.304-1.451-.086-2.906-.126-4.363-.206-1.611-.09-3.223-.174-4.836-.304-2.288-.179-4.566-.403-6.853-.588-1.626-.13-3.252-.256-4.902-.1-.936.091-1.9-.05-2.835-.179-1.348-.183-2.7-.17-4.055-.186-1.653-.017-3.307-.029-4.965-.052-.476-.007-.947-.06-1.423-.067-.13-.008-.267.059-.4.085.055.119.077.282.172.351.565.417 1.151.8 1.716 1.218 1.5 1.11 2.999 2.222 4.491 3.344.576.435.915 1.051 1.274 1.651.218.367.042.685-.137.974-.173.278-.284.664-.705.712-.288.034-.577.068-.869.072-1.449.03-2.753-.444-4.039-.993-.918-.393-1.821-.825-2.753-1.196a1.417 1.417 0 0 1-.805-.75c-.12-.25-.219-.562-.621-.24-.18.138-.402.1-.575-.1-.255-.294-.553-.561-.807-.86-.172-.207-.365-.254-.638-.266-1.027-.024-1.844-.485-2.444-1.268-.385-.504-.892-.836-1.462-1.057-.662-.256-1.258-.593-1.734-1.08a69.905 69.905 0 0 1-2.53-2.758c-.352-.404-.277-1.196.103-1.606.683-.737 1.392-1.443 2.058-2.192.356-.405.635-.879.964-1.314.135-.177.274-.41.464-.48.744-.276 1.217-.853 1.766-1.361.227-.211.467-.445.745-.566.904-.4 1.817-.775 2.745-1.11.27-.098.606.004.911-.011.138-.01.343-.042.398-.131.486-.796 1.23-1.205 2.129-1.287 1.374-.128 2.659-.601 3.98-.94 1.52-.39 3.042-.773 4.56-1.186C22.527.86 23.711.715 24.915.7c.513-.009.892.223 1.084.61.415.853.512.83-.093 1.635-.115.155-.246.297-.338.464-.354.66-1.01.803-1.654 1.034-1.105.393-2.186.85-3.262 1.314-1.41.61-2.798 1.257-4.197 1.879-.755.34-1.525.638-2.265 1.001-.74.364-1.448.781-2.254 1.222l-.014.033z"
        })
    });
};
const $28812ae5faf1418d$export$eec9700d5a261698 = ()=>{
    const intl = (0, $f6qj2.default)();
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "jpd-atlassianIntelligence",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            id: "atlassian-intelligence",
            ref: scrollRef,
            className: (0, $esG4f.default)([
                "_85i51wqb _1reo15vq _18m915vq",
                sectionIsVisible ? "is-visible" : ""
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_kqswstnw _152tidpf _1e021ssb _t9eczr6s _1bsbtfvk _p12fauwl _bfhkqlpt _1pby1mrw _4t3i1w8u _mkrz1wiv _165t1mqo _1cfr1y69",
                                "background"
                            ])
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _4cvr1h6o _2lx21bp4 _kqswh2mm",
                                "content-wrapper"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _4cvr1h6o _2lx21bp4 _zulp4bvh _p12f32xz _1q511k4y _kqswh2mm _y3gn1h6o _81641tcg"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _srwzi2wt"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _zulp1crf _6rthzwfg",
                                                    "branding"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                                    image: {
                                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/228i1sr1dfw1gwf6gej5q22wij418525.svg",
                                                        alt: "Atlassian Intelligence",
                                                        width: 32,
                                                        height: 32
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                                className: (0, $esG4f.default)([
                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz12cp _1pby11wp",
                                                    "_1rkb1w8u"
                                                ]),
                                                children: intl.formatMessage({
                                                    id: "JiraProductDiscoveryPage.atlassianIntelligence.header",
                                                    defaultMessage: "Transform teamwork with human-AI collaboration"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        text: intl.formatMessage({
                                            id: "JiraProductDiscoveryPage.atlassianIntelligence.ctaText",
                                            defaultMessage: "Explore Atlassian Intelligence"
                                        }),
                                        href: (0, $3FBn4.useLocalizedHref)("/software/artificial-intelligence"),
                                        type: "primary",
                                        bgColor: "bgBlackBlue",
                                        dataEventProps: {
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "ctaSection",
                                            "data-product-key": "jiraProductDiscovery",
                                            "data-label-english": "Explore Atlassian Intelligence"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_kqswh2mm _1h1tcq2i _1bsb1osq _lcxvglyw"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$LeftArrows, {
                                                sectionIsVisible: sectionIsVisible
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$RightArrows, {
                                                sectionIsVisible: sectionIsVisible
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                                image: {
                                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/w5a2w16s762570j03psv36nc66c7bpuk.webp",
                                                    alt: "",
                                                    width: 1920,
                                                    height: 1080
                                                },
                                                style: {
                                                    maxWidth: "100%",
                                                    height: "auto"
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $28812ae5faf1418d$var$LeftArrows = ({ sectionIsVisible: sectionIsVisible })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _152tidpf _1pbycs5v",
            "_152tubeo _1e02tidb _1vxpvqxi _mmgkvkhr _jj7e1xgq _zsl9vkhr _17s11xgq _dqt7vkhr"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqu7fg"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointLeft, {
                    color: "#1868DB",
                    rotate: 200
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1j6v"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointLeft, {
                    color: "#BC5DF2",
                    rotate: 222
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqb8yl"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointLeft, {
                    color: "#fff",
                    rotate: 219
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1gop"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointLeft, {
                    color: "#101214",
                    rotate: 196
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1r2e"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointLeft, {
                    color: "#B9D58D",
                    rotate: 199
                })
            })
        ]
    });
};
const $28812ae5faf1418d$var$RightArrows = ({ sectionIsVisible: sectionIsVisible })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _152tidpf _1pbycs5v",
            "_152t11oi _1e02sisq _1vxp1ebb _mmgk189v _jj7etpnp _zsl9189v _17s1tpnp _dqt7189v"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqwpsi"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointRight, {
                    color: "#1868DB",
                    rotate: 139
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1xrr"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointRight, {
                    color: "#fff",
                    rotate: 127
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq59wa"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointRight, {
                    color: "#82B536",
                    rotate: 114
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqmgyd"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointRight, {
                    color: "#101214",
                    rotate: 138
                })
            })
        ]
    });
};
const $28812ae5faf1418d$var$sectionStyles = null;
const $28812ae5faf1418d$var$arrowStyles = null;
const $28812ae5faf1418d$var$wrapperStyles = null;
const $28812ae5faf1418d$var$leftAndRightArrowsStyles = null;
const $28812ae5faf1418d$var$svgStyles = null;
const $28812ae5faf1418d$var$leftArrowsStyles = null;
const $28812ae5faf1418d$var$rightArrowsStyles = null;
const $28812ae5faf1418d$var$headerStyles = null;
const $28812ae5faf1418d$var$containerStyles = null;
const $28812ae5faf1418d$var$backgroundStyles = null;
const $28812ae5faf1418d$var$textWrapperStyles = null;
const $28812ae5faf1418d$var$textStyles = null;
const $28812ae5faf1418d$var$brandingStyles = null;
const $28812ae5faf1418d$var$imageWrapperStyles = null;
const $28812ae5faf1418d$var$fadeIn = null;
const $28812ae5faf1418d$var$fadeInAnimation = null;
const $28812ae5faf1418d$var$arrowLeft1 = null;
const $28812ae5faf1418d$var$arrowLeft1Animation = null;
const $28812ae5faf1418d$var$arrowLeft2 = null;
const $28812ae5faf1418d$var$arrowLeft2Animation = null;
const $28812ae5faf1418d$var$arrowLeft3 = null;
const $28812ae5faf1418d$var$arrowLeft3Animation = null;
const $28812ae5faf1418d$var$arrowLeft4 = null;
const $28812ae5faf1418d$var$arrowLeft4Animation = null;
const $28812ae5faf1418d$var$arrowLeft5 = null;
const $28812ae5faf1418d$var$arrowLeft5Animation = null;
const $28812ae5faf1418d$var$arrowRight1 = null;
const $28812ae5faf1418d$var$arrowRight1Animation = null;
const $28812ae5faf1418d$var$arrowRight2 = null;
const $28812ae5faf1418d$var$arrowRight2Animation = null;
const $28812ae5faf1418d$var$arrowRight3 = null;
const $28812ae5faf1418d$var$arrowRight3Animation = null;
const $28812ae5faf1418d$var$arrowRight4 = null;
const $28812ae5faf1418d$var$arrowRight4Animation = null;

});

parcelRegister("5twbI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f436400e57f4fd3$export$2e2bcd8739ae039; });
/* community.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");
const $2f436400e57f4fd3$var$Community = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1mou1epz"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
            layout: "6-6",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/tj67uy2v6dlh816537m17ay3p0qwy6y2.webp",
                        alt: ""
                    },
                    className: (0, $esG4f.default)([
                        "_rtys1osq _bna71wug _1vr0xy5q"
                    ])
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: "h4",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraProductDiscoveryPage.community.heading",
                                defaultMessage: "Join us in the Atlassian Community"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraProductDiscoveryPage.community.subheading",
                                defaultMessage: "Ask questions, give app feedback, and connect with our team and other users to learn best practices."
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                            text: intl.formatMessage({
                                id: "JiraProductDiscoveryPage.community.ctaText",
                                defaultMessage: "Join the discussion"
                            }),
                            href: "https://community.atlassian.com/t5/Jira-Product-Discovery/ct-p/jpd",
                            type: "primary",
                            dataEventProps: {
                                "data-event-component": "linkButton",
                                "data-event-container": "pronouncedCtaSection",
                                "data-event": "clicked",
                                "data-product-key": "jiraProductDiscovery"
                            }
                        })
                    ]
                })
            ]
        })
    });
};
var $2f436400e57f4fd3$export$2e2bcd8739ae039 = $2f436400e57f4fd3$var$Community;
const $2f436400e57f4fd3$var$section = null;
const $2f436400e57f4fd3$var$img = null;

});

parcelRegister("h0v1e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67f5ab58647a7f49$export$2e2bcd8739ae039; });
/* cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $i8kxh = parcelRequire("i8kxh");

var $91nJf = parcelRequire("91nJf");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $67f5ab58647a7f49$var$CtaSection = ()=>{
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1reo15vq _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            layout: "12",
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _y3gn1h6o _6rthxncg _1q51xncg _85i5xy5q _1e0c1txw _2lx21bp4 _4cvr1h6o _zulppxbi _1cs8stnw _1g0v1mrw _1kt9b3bt _1812ukr8 _gs7s10v4 _1rusbq5w _7dwz6xro _1kwxdcea _jbut1ssa _5t3m1oci _m2uvwt5r _18postnw _1bqq1mrw _aetrb3bt _13w1ukr8 _16gxmgjw _1hfkb29m _3p6m1cq2 _1v5vmgnk _z0bc1h14 _19h9d943 _1oj4kh7c _otsx1cpx _wi3iz9ld _tzs91clp"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_syaz1gfe _1mouidpf _14b51n8h _1m0r1wug",
                            "_1cs8stnw _1mp410mc _kfgt10mc _1kt9b3bt _1s6k11z8 _1ank5vt7 _cfu11o8l _7dwz4djf"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "JiraProductDiscoveryPage.cta.section.heading",
                            defaultMessage: "<span>Build</span> better features, not more features.",
                            values: {
                                span: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        children: chunks
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_syaz1gfe _1mouidpf _14b51n8h _1m0r1wug",
                            "body-lg"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "JiraProductDiscoveryPage.cta.section.subheading",
                            defaultMessage: "Leave the guess work behind and build products your customers love."
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                        color: "yellow",
                        variant: "primary",
                        size: "small",
                        dataEventProps: {
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-product-key": "jiraProductDiscovery",
                            "data-label-english": "Get it free",
                            "data-track-event": "jiraProductDiscovery.get-it-free-button-clicked"
                        },
                        href: signupLink,
                        onClick: openCrossFlow,
                        className: (0, $esG4f.default)([
                            "_1pfhpxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "JiraProductDiscoveryPage.cta.section.cta.text",
                            defaultMessage: "Get it free"
                        })
                    })
                ]
            })
        })
    });
};
var $67f5ab58647a7f49$export$2e2bcd8739ae039 = $67f5ab58647a7f49$var$CtaSection;
const $67f5ab58647a7f49$var$container = null;
const $67f5ab58647a7f49$var$sectionStyle = null;
const $67f5ab58647a7f49$var$textStyle = null;
const $67f5ab58647a7f49$var$accent = null;
const $67f5ab58647a7f49$var$button = null;

});

parcelRegister("bWsik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13a927b880777675$export$2e2bcd8739ae039; });
/* customers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $13a927b880777675$var$sectionStyle = null;
const $13a927b880777675$var$logosGridStyle = null;
const $13a927b880777675$var$liStyle = null;
const $13a927b880777675$var$Customers = ()=>{
    const logos = [
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/260w4830ha12g7838ik7j5rq3ex31h8h.svg",
            alt: "Canva",
            width: 136,
            height: 43
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4ojx82fmj7q6l0354r1qfe572un65j0m.svg",
            alt: "Coupa",
            width: 158
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g76770b7kmwx457yu43qbo42h874ann8.svg",
            alt: "Docker",
            width: 158
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7ivn8866tpd7e4155176u71d4syycwc8.webp",
            alt: "The Economist",
            width: 112
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4x7bp61gn38200m4omcfxsx0cm75w71i.svg",
            alt: "Deliveroo",
            width: 148
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/mmi427i07l27j8ul2aj32h25144vb65u.svg",
            alt: "Decathlon",
            width: 156
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_6rth12bs _y3gn1h6o _syazvejh"
        ]),
        style: {
            "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: "h5",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "JiraProductDiscoveryPage.customers.heading",
                        defaultMessage: "Join the 10,000+ customers who build products with Jira Product Discovery"
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                    className: (0, $esG4f.default)([
                        "_1e0c11p5 _zulpviql _yv0e14qi _4cvr1h6o _6a6z1h6o _19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1bsb1osq _rtys1osq _1da7nl51 _1rqt1g7m"
                    ]),
                    children: logos.map((logo)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                            className: (0, $esG4f.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: (0, $7Knp0._)({}, logo)
                            })
                        }, logo.src))
                })
            })
        ]
    });
};
var $13a927b880777675$export$2e2bcd8739ae039 = $13a927b880777675$var$Customers;

});

parcelRegister("2m2Kl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fca3dc2ec5a05c1b$export$2e2bcd8739ae039; });
/* demo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $91nJf = parcelRequire("91nJf");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $fca3dc2ec5a05c1b$var$bannerStyle = null;
const $fca3dc2ec5a05c1b$var$imgStyle = null;
const $fca3dc2ec5a05c1b$var$buttonStyle = null;
const $fca3dc2ec5a05c1b$var$DemoBanner = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_11q7owgw _2rkovwyg _1e0c11p5 _yv0ehkll _4cvr1h6o _6a6z1h6o _zulp1ejb _1bsb1osq _1q51xy5q _18zrpxbi _6rthxy5q _y3gn1h6o _12e81fhb _uj6kv2br _1j8b7y8c _16imze3t _su07xy5q _jplc1xh7 _bj231xh7"
            ]),
            style: {
                "--_1lpv4ka": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.lime")),
                "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: "h3",
                    children: intl.formatMessage({
                        id: "JiraProductDiscoveryPage.demo.body.text",
                        defaultMessage: "Join our demo with live chat Q&A"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                    variant: "secondary",
                    color: "black",
                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/demo"),
                    dataEventProps: {
                        "data-event": "clicked",
                        "data-event-container": "banner-link-button",
                        "data-event-component": "linkButton",
                        "data-product-key": "jiraProductDiscovery"
                    },
                    className: (0, $esG4f.default)([
                        "_10fp1h6o"
                    ]),
                    children: intl.formatMessage({
                        id: "JiraProductDiscoveryPage.demo.cta.text",
                        defaultMessage: "Register now"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ua18axib18162bej4n515osj7675wepi.webp",
                        alt: intl.formatMessage({
                            id: "JiraProductDiscoveryPage.demo.screenshot.alt",
                            defaultMessage: "Screenshot of Jira Product Discovery"
                        }),
                        width: 368,
                        height: 154
                    },
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1wpzesu3 _p12f1osq _1kr6kb7n _dz5jcs5v _rtys1osq _bna71wug"
                    ])
                })
            ]
        })
    });
};
var $fca3dc2ec5a05c1b$export$2e2bcd8739ae039 = $fca3dc2ec5a05c1b$var$DemoBanner;

});

parcelRegister("fnNPE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad3bf2e3963eccf6$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $91nJf = parcelRequire("91nJf");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $ad3bf2e3963eccf6$var$Hero = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            layout: "8",
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _1rjc1lhf _26vxxncg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _1g0v1mrw _1cs8stnw _1kt9b3bt _1tes18wq _18crxkqj _f6gemgnk _wkf1wsfl _1nrl42os _1gg83zxr",
                            "superhero"
                        ]),
                        children: intl.formatMessage({
                            id: "JiraProductDiscoveryPage.hero.heading.super",
                            defaultMessage: "From ideas to <em>impact</em>, build what matters"
                        }, (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                            em: (text)=>{
                                return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                    className: (0, $esG4f.default)([
                                        "_kqswh2mm _1cs8stnw _1kt9b3bt _1tesidpf _18crnqtd _f6gemgnk _wkf1174u _7dwz1vci _5z7wyan6 _1kwx1wlv _5t3mz98b"
                                    ]),
                                    children: text
                                });
                            }
                        }))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: "body-lg",
                        children: intl.formatMessage({
                            id: "JiraProductDiscoveryPage.hero.subtitle",
                            defaultMessage: "Capture insights, prioritize ideas, and build roadmaps - all in Jira"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                        href: signupLink,
                        onClick: openCrossFlow,
                        variant: "primary",
                        dataEventProps: {
                            "data-event": "clicked",
                            "data-event-container": "heroSection",
                            "data-event-component": "linkButton",
                            "data-product-key": "jiraProductDiscovery",
                            "data-label-english": "Get it free",
                            "data-track-event": "jiraProductDiscovery.get-it-free-button-clicked"
                        },
                        className: (0, $esG4f.default)([
                            "_1pfhpxbi"
                        ]),
                        children: intl.formatMessage({
                            id: "JiraProductDiscoveryPage.hero.cta.label",
                            defaultMessage: "Get it free"
                        })
                    })
                ]
            })
        })
    });
};
var $ad3bf2e3963eccf6$export$2e2bcd8739ae039 = $ad3bf2e3963eccf6$var$Hero;
const $ad3bf2e3963eccf6$var$container = null;
const $ad3bf2e3963eccf6$var$heroContainer = null;
const $ad3bf2e3963eccf6$var$heading = null;
const $ad3bf2e3963eccf6$var$impact = null;
const $ad3bf2e3963eccf6$var$button = null;

});

parcelRegister("bvUhK", function(module, exports) {

$parcel$export(module.exports, "HowItWorks", function () { return $c6ee42b1c3c776e3$export$409faa00494a55a; });
/* how-it-works.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $cutM5 = parcelRequire("cutM5");
parcelRequire("bGE1b");
var $1p5F6 = parcelRequire("1p5F6");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $cYqjE = parcelRequire("cYqjE");

var $28vYy = parcelRequire("28vYy");
const $c6ee42b1c3c776e3$export$409faa00494a55a = ()=>{
    const intl = (0, $f6qj2.default)();
    const cardRef = (0, $iSvIT.useRef)(null);
    const [activeTeamIndex, setActiveTeamIndex] = (0, $iSvIT.useState)(0);
    const [activeTeamData, setActiveTeamData] = (0, $iSvIT.useState)((0, $cYqjE.TEAM_DATA)[0]);
    (0, $iSvIT.useEffect)(()=>{
        setActiveTeamData((0, $cYqjE.TEAM_DATA)[activeTeamIndex]);
    }, [
        activeTeamIndex
    ]);
    const renderActiveMedia = ()=>{
        const { heroImage: heroImage, contentTitle: contentTitle, contentText: contentText, quoteColor: quoteColor, quoteText: quoteText, customerName: customerName, customerTitle: customerTitle } = activeTeamData;
        const quoteProps = {
            quoteColor: quoteColor,
            quoteText: intl.formatMessage(quoteText),
            customerName: intl.formatMessage(customerName),
            customerTitle: intl.formatMessage(customerTitle)
        };
        return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                    layout: "4-8",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                    children: intl.formatMessage(contentTitle)
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    children: intl.formatMessage(contentText)
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_kzviglyw"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $28vYy.default), (0, $7Knp0._)({}, quoteProps))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_mezj1osq _bna71wug"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: {
                                    src: heroImage,
                                    alt: ""
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_dm25glyw _sugaglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $28vYy.default), (0, $7Knp0._)({}, quoteProps))
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "homepage-v2-hero",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            id: "hero-jira-cta",
            className: (0, $esG4f.default)([
                "_1reo15vq _18m915vq _6rth1ylp"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_ect41pz4 _1wyb1ylp _k48p1fw0 _vwz4ckbl _y3gn1h6o"
                            ]),
                            style: {
                                "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_kqswh2mm _18postnw _z0ai1qo0 _1qdg1qjk _1guf1lpd _1czd17hu _aetrb3bt _3p6m1s0j _1mhxca9o _1nww1ul9 _1y2q17rr _sjmw1lpd _1efb101a"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "JiraProductDiscoveryPage.howItWorks.header",
                                    defaultMessage: "How it works",
                                    values: {
                                        teams: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1p5F6.Adg4TextUnderline), {
                                                underline: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                                                    width: "100%",
                                                    height: "30",
                                                    viewBox: "0 0 306 42",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                        d: "M0.314542 22.3672C52.9464 14.9125 91.8245 33.6666 144.966 18.1254C147.46 24.7349 153.892 33.0058 163.497 33.1094C155.486 32.9725 142.641 15.7178 155.536 27.2686C163.119 36.0683 196.172 25.2364 170.842 32.944C188.334 31.2885 204.356 20.5339 216.163 10.9702C235.811 -2.65832 220.928 23.6737 235.178 36.8756C255.37 55.2242 316.463 7.29572 304.134 7.28816C296.296 13.2947 285.769 17.046 281.423 23.6985C204.757 63.1757 259.992 -9.72674 214.311 2.55426C139.744 53.2533 177.393 7.4163 133.572 10.6223C108.06 28.9946 -0.613806 0.46356 0.29434 22.3672L0.314542 22.3672Z",
                                                        fill: "#FFA900"
                                                    })
                                                }),
                                                children: str
                                            }),
                                        br: /*#__PURE__*/ (0, $loA2J.jsx)("br", {})
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            ref: cardRef,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4Tabs), {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _1bah1yb4 _19pkidpf _2hwx1wug _otyridpf _18u01wug _6rth12am _zulpckbl"
                                        ]),
                                        children: (0, $cYqjE.TEAM_DATA).map(({ title: title, id: id, icon: icon, englishLabel: englishLabel }, index)=>{
                                            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                                                onClick: ()=>{
                                                    setActiveTeamIndex(index);
                                                },
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                                    "data-product-key": "home",
                                                    "data-event-component": "button",
                                                    "data-event-container": "heroSection",
                                                    "data-event": "clicked",
                                                    "data-label-english": englishLabel,
                                                    "aria-label": intl.formatMessage(title),
                                                    className: (0, $esG4f.default)([
                                                        "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _d0altlke"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                                        className: (0, $esG4f.default)([
                                                            "_vchhusvi _1e0c1txw _2lx21bp4 _1bsbh2q2 _4cvr1h6o _ca0qi2wt _u5f3i2wt _n3tdi2wt _19bvi2wt _zulpidpf _2rkoi2wt _19itt94y _11q7m7j4 _1j55glyw _19lc15ej _kbawglyw _1x381ule",
                                                            activeTeamIndex === index && "_19it1dfy _2rkoi2wt _1kd31fw0"
                                                        ]),
                                                        children: [
                                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                                className: (0, $esG4f.default)([
                                                                    "_4t3i3okq _1bsb3okq _mezj3okq _bna73okq",
                                                                    "default-icon"
                                                                ]),
                                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                                                    image: {
                                                                        src: `${icon}`,
                                                                        alt: "",
                                                                        draggable: "false"
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                                className: (0, $esG4f.default)([
                                                                    "_4t3i3okq _1bsb3okq _mezj3okq _bna73okq",
                                                                    "hover-icon"
                                                                ]),
                                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                                                    image: {
                                                                        src: icon,
                                                                        alt: "",
                                                                        draggable: "false"
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                                className: (0, $esG4f.default)([
                                                                    "_ect41pz4 _k48p1nn1 _1wyb1j6v _vwz41k8s _syazqlpt"
                                                                ]),
                                                                style: {
                                                                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                                                                },
                                                                children: intl.formatMessage(title)
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, id);
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                            children: renderActiveMedia()
                        })
                    ]
                })
            })
        })
    });
};
const $c6ee42b1c3c776e3$var$jiraHeroStyles = null;
const $c6ee42b1c3c776e3$var$heroTitleStyles = null;
const $c6ee42b1c3c776e3$var$heroTitleSpanStyles = null;
const $c6ee42b1c3c776e3$var$buttonResetStyle = null;
const $c6ee42b1c3c776e3$var$tabsStyle = null;
const $c6ee42b1c3c776e3$var$teamCardStyles = null;
const $c6ee42b1c3c776e3$var$iconContainerStyles = null;
const $c6ee42b1c3c776e3$var$teamCardTextStyles = null;
const $c6ee42b1c3c776e3$var$teamCardActiveStyles = null;
const $c6ee42b1c3c776e3$var$imageOverrideStyles = null;
const $c6ee42b1c3c776e3$var$quoteStyles = null;
const $c6ee42b1c3c776e3$var$tabletQuoteStyles = null;

});
parcelRegister("bGE1b", function(module, exports) {
$parcel$export(module.exports, "Adg4TextUnderline", function () { return (parcelRequire("1p5F6")).Adg4TextUnderline; });
parcelRequire("1p5F6");

});
parcelRegister("1p5F6", function(module, exports) {

$parcel$export(module.exports, "Adg4TextUnderline", function () { return $23a59b9be0d723ab$export$a8ef4069b9c5e8b7; });
/* text-underline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");
const $23a59b9be0d723ab$var$textStyle = null;
const $23a59b9be0d723ab$var$inViewTextStyle = null;
const $23a59b9be0d723ab$var$underlineStyle = null;
const $23a59b9be0d723ab$var$inViewUnderlineStyle = null;
const $23a59b9be0d723ab$var$hiddenText = null;
const $23a59b9be0d723ab$var$visibleText = null;
const $23a59b9be0d723ab$export$a8ef4069b9c5e8b7 = ({ text: text, children: children, underline: underline, underlineInset: underlineInset = "-37.5%", underlineLeft: underlineLeft = false, fontWeight: fontWeight = {
    from: 400,
    to: 800
}, useInViewOptions: useInViewOptions })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)(useInViewOptions);
    const fontWeightAnimation = null;
    const underlineInsetStyle = null;
    const toFontWeight = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        ref: scrollRef,
        className: (0, $esG4f.default)([
            "_1e0c116y _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _ju251bs3 _5sagfnf5 _tip8kb7n _1o51q7pw _vwz4kb7n _1nmz1hna",
            sectionIsVisible && "_j7hq1dkr"
        ]),
        style: {
            "--_15xzfe0": (0, $43MIc.default)(fontWeight.from),
            "--_1bgzcf7": (0, $43MIc.default)(fontWeight.to)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                "aria-hidden": true,
                className: (0, $esG4f.default)([
                    "_3um015vq _lcxvglyw",
                    "_k48p103h"
                ]),
                style: {
                    "--_1bgzcf7": (0, $43MIc.default)(fontWeight.to)
                },
                children: text !== null && text !== void 0 ? text : children
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _1e02idpf"
                ]),
                children: text !== null && text !== void 0 ? text : children
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bsb1osq _mkrz16t8 _ju251bs3 _5sagpwmj _tip8kb7n _1e02idpf _1o51q7pw _kqswstnw _1pby1mrw",
                    "_u7co11y5 _cjf710zq _1kni10zq",
                    sectionIsVisible && "_j7hqzu28"
                ]),
                style: {
                    "--_1jmpxqi": (0, $43MIc.default)(underlineInset),
                    "--_p0j3r4": (0, $43MIc.default)(underlineLeft ? "0" : "auto")
                },
                children: underline
            })
        ]
    });
};

});


parcelRegister("cYqjE", function(module, exports) {

$parcel$export(module.exports, "TEAM_DATA", function () { return $cf5d85e4a8ac8e6e$export$860b41270ca4de2e; });

var $6x1qA = parcelRequire("6x1qA");
const $cf5d85e4a8ac8e6e$export$860b41270ca4de2e = [
    {
        id: "software",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/0tktsadc6a0h85663hv4lb34mml07y0g.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/1l8b1267j66mc1b334eua3gyam2nggrx.webp",
        title: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.label.tab1",
            defaultMessage: "Capture"
        }),
        englishLabel: "Capture",
        contentTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.title.tab1",
            defaultMessage: "Capture ideas and insights"
        }),
        contentText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.text.tab1",
            defaultMessage: "There\u2019s now a home for all the unstructured work that happens before you start building software. Gather and organize your product opportunities, user feedback, and feature requests all in one place."
        }),
        quoteColor: "blue",
        quoteText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab1",
            defaultMessage: "Jira Product Discovery is helping us do the right things, in the right order, and at the right time, focusing on work that will deliver on benefits."
        }),
        customerName: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab1",
            defaultMessage: "John Sayers"
        }),
        customerTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab1",
            defaultMessage: "PMO Lead, Renaissancere"
        })
    },
    {
        id: "product-management",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/kha7lb4n41e6nqbfm6uu8jwym0dumt36.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/ohh610p3j7iv5hyda53yqh0006v40258.webp",
        title: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.label.tab2",
            defaultMessage: "Prioritize"
        }),
        englishLabel: "Prioritize",
        contentTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.title.tab2",
            defaultMessage: "Prioritize \u2013 your way"
        }),
        contentText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.text.tab2",
            defaultMessage: "Flexible views and granular fields let you compare ideas against one another using the prioritization method that works best for you."
        }),
        quoteColor: "lime",
        quoteText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab2",
            defaultMessage: "Up until Jira Product Discovery, even with other roadmapping tools, we\u2019ve had to use shared spreadsheets and slide presentations to coordinate prioritization in an accessible way. However, within a week of \u201Ctrying\u201D out Jira Product Discovery, it became clear it was the tool to invest in going forward."
        }),
        customerName: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab2",
            defaultMessage: "John Daily Jr."
        }),
        customerTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab2",
            defaultMessage: "Head of Product, Karhoo"
        })
    },
    {
        id: "marketing",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/36m76eu4oo0e46hvd21s744fn11i35q5.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/2fh1741j5vly80365ofehwwe0qes6b4a.webp",
        title: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.label.tab3",
            defaultMessage: "Engage"
        }),
        englishLabel: "Engage",
        contentTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.title.tab3",
            defaultMessage: "Engage and align your teams"
        }),
        contentText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.text.tab3",
            defaultMessage: "Create and share roadmaps tailored to individual stakeholders \u2013 even ones outside your organization \u2013 and let them provide feedback via comments, votes, or simple reactions."
        }),
        quoteColor: "purple",
        quoteText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab3",
            defaultMessage: "Jira Product Discovery has revitalized how we think about roadmaps."
        }),
        customerName: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab3",
            defaultMessage: "Adam Chapman"
        }),
        customerTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab3",
            defaultMessage: "Full Stack Developer, Apex Networks"
        })
    },
    {
        id: "project-management",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/3e2ln2b76w2544cn5633031qjtn2fobe.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/r1elfv055406ty7x72u4000npq20n46m.webp",
        title: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.label.tab4",
            defaultMessage: "Connect"
        }),
        englishLabel: "Connect",
        contentTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.title.tab4",
            defaultMessage: "Connect teams, all in Jira"
        }),
        contentText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.text.tab4",
            defaultMessage: "Seamlessly connect your ideas to delivery work in Jira so your teams have full context and visibility from discovery to delivery."
        }),
        quoteColor: "yellow",
        quoteText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab4",
            defaultMessage: "Jira Product Discovery combines everything I was doing in spreadsheets and Powerpoints into one easy-to-navigate tool. Plus everything is added straight into Jira, instead of requiring some third-party tool to integrate."
        }),
        customerName: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab4",
            defaultMessage: "Abby Kiesling"
        }),
        customerTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab4",
            defaultMessage: "Product Manager, EZ Texting"
        })
    }
];

});

parcelRegister("28vYy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eed829f7fc44a38$export$2e2bcd8739ae039; });
/* testimonial-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("3QHAr");
var $bESgj = parcelRequire("bESgj");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");
const $6eed829f7fc44a38$var$quoteStyles = null;
const $6eed829f7fc44a38$var$quotePStyles = null;
const $6eed829f7fc44a38$var$portraitStyles = null;
const $6eed829f7fc44a38$var$nameStyles = null;
const $6eed829f7fc44a38$var$titleStyles = null;
const $6eed829f7fc44a38$var$quoteSrcMap = {
    yellow: "https://dam-cdn.atl.orangelogic.com/AssetLink/3ixqjd5540sdn251h25h55i82occ48sa.svg",
    purple: "https://dam-cdn.atl.orangelogic.com/AssetLink/0ho3162460jba51mgj0a16k3cpvy074s.svg",
    lime: "https://dam-cdn.atl.orangelogic.com/AssetLink/q6j1k002cmxpvr2145m8q3u70gfrm2qt.svg",
    blue: "https://dam-cdn.atl.orangelogic.com/AssetLink/504175ycu5d01061dg4evte5l0m72pea.svg",
    none: ""
};
const $6eed829f7fc44a38$var$TestimonialQuote = ({ quoteText: quoteText, customerName: customerName, customerTitle: customerTitle, quoteColor: quoteColor, colorAgainst: colorAgainst })=>{
    const quoteImage = {
        src: $6eed829f7fc44a38$var$quoteSrcMap[quoteColor],
        alt: customerTitle
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_11q7qbzx _ca0q1ul9 _u5f3gktf _n3td1ul9 _19bv53f4 _kqswh2mm _1pfhzwfg _14dk1fw0"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _19pkidpf _2hwxidpf _otyr1j6v _18u0idpf _ect4bzd7 _1wybdlk8 _k48p1nn1 _vwz4gktf _y3gn1e5h",
                            "body-sm"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: quoteText
                    }),
                    quoteColor !== "none" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _1bsb88uy _1e02gktf _152tgktf"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                            image: quoteImage
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1mt11ul9",
                            "body-sm name"
                        ]),
                        children: customerName
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1p1dangw",
                            "fine-print"
                        ]),
                        children: customerTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bESgj.Adg4SectionDivider), {
                variation: (0, $bESgj.SECTION_DIVIDER_VARIATION).FLIP,
                desktopHeight: 15,
                tabletHeight: 15,
                mobileHeight: 15,
                bgColor: "var(--ds-surface-sunken, #F7F8F9)",
                colorAgainst: colorAgainst
            })
        ]
    });
};
var $6eed829f7fc44a38$export$2e2bcd8739ae039 = $6eed829f7fc44a38$var$TestimonialQuote;

});
parcelRegister("3QHAr", function(module, exports) {
$parcel$export(module.exports, "Adg4SectionDivider", function () { return (parcelRequire("bESgj")).Adg4SectionDivider; });
$parcel$export(module.exports, "SECTION_DIVIDER_VARIATION", function () { return (parcelRequire("bESgj")).SECTION_DIVIDER_VARIATION; });
parcelRequire("bESgj");

});
parcelRegister("bESgj", function(module, exports) {

$parcel$export(module.exports, "SECTION_DIVIDER_VARIATION", function () { return $895786c36feeeaea$export$89ad02e8b5e6fb05; });
$parcel$export(module.exports, "Adg4SectionDivider", function () { return $895786c36feeeaea$export$2446497a3d298a13; });
/* section-divider.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
var $895786c36feeeaea$export$89ad02e8b5e6fb05;
(function(SECTION_DIVIDER_VARIATION) {
    SECTION_DIVIDER_VARIATION["NORMAL"] = "normal";
    SECTION_DIVIDER_VARIATION["REVERSE"] = "reverse";
    SECTION_DIVIDER_VARIATION["FLIP"] = "flip";
    SECTION_DIVIDER_VARIATION["REVERSE_FLIP"] = "reverse-flip";
})($895786c36feeeaea$export$89ad02e8b5e6fb05 || ($895786c36feeeaea$export$89ad02e8b5e6fb05 = {}));
const $895786c36feeeaea$export$2446497a3d298a13 = ({ bgColor: bgColor = "#1868DB", colorAgainst: colorAgainst = "#FFF", desktopHeight: desktopHeight = 120, tabletHeight: tabletHeight = 80, mobileHeight: mobileHeight = 60, variation: variation })=>{
    const sectionDividerStyles = null;
    const colorBehindDividerStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_bfhk1tls"
        ]),
        style: {
            "--_1gwlqo7": (0, $43MIc.default)(colorAgainst)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_mkrzsrs8 _11q7bs0x _4t3iepwt _1vkh1mjl _tnruenus",
                variation === "reverse" && "_mkrz1fra",
                variation === "flip" && "_mkrz1n6g",
                variation === "reverse-flip" && "_mkrz1vud"
            ]),
            style: {
                "--_1w9snyi": (0, $43MIc.default)(bgColor),
                "--_qqqbix": (0, $43MIc.default)(desktopHeight, "px"),
                "--_1ly4yra": (0, $43MIc.default)(tabletHeight, "px"),
                "--_klg1fm": (0, $43MIc.default)(mobileHeight, "px")
            }
        })
    });
};

});




parcelRegister("iGwIR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d33928026e868f01$export$2e2bcd8739ae039; });
/* side-by-side.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bhreu = parcelRequire("bhreu");
parcelRequire("ElG1F");
var $1bVgT = parcelRequire("1bVgT");
const $d33928026e868f01$var$SideBySide = ()=>{
    const intl = (0, $f6qj2.default)();
    const items = [
        {
            title: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.1.title",
                defaultMessage: "Bring structure to chaos"
            }),
            description: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.1.description",
                defaultMessage: "Leverage data and customer insights to help your team prioritize ideas that will make the biggest impact."
            }),
            img: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8i4ut65m3p28wvyedk7505mtqm5kiqr3.webp",
                alt: "",
                width: 768,
                height: 512
            }
        },
        {
            title: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.2.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.2.description",
                defaultMessage: "Spend less time updating and persuading with custom roadmaps that give your stakeholders the information they need."
            }),
            img: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g5xp0826vanhei54fi3437v7nr227cn7.webp",
                alt: "",
                width: 768,
                height: 512
            }
        },
        {
            title: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.3.title",
                defaultMessage: "Connect discovery and delivery in Jira"
            }),
            description: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.3.description",
                defaultMessage: "Reduce context switching, add visibility, and move faster by seamlessly connecting your ideas to the delivery work happening in Jira."
            }),
            img: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/767r1t8n744265g8k4550obw1udklx2f.webp",
                alt: "",
                width: 768,
                height: 512
            }
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1reozryt"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1bVgT.Scroller), {
                items: items,
                renderText: (item)=>/*#__PURE__*/ (0, $loA2J.jsx)($d33928026e868f01$var$ScrollerContent, {
                        item: item
                    }),
                renderGraphic: (item)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: item.img,
                        className: (0, $esG4f.default)([
                            "_p12f1osq _rtys1osq _bna71wug"
                        ])
                    }),
                layout: "right",
                mobileGraphicLayout: "above",
                backgroundColor: "#fff",
                inScrollBackgroundColor: "#fff",
                heading: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_y3gn1h6o _1bsb1osq _1e0c11p5 _85i5xy5q"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_6rthidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraProductDiscoveryPage.scroller.heading.text",
                                defaultMessage: "Discover your next great product idea"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraProductDiscoveryPage.scroller.subheading.text",
                                defaultMessage: "Better product decisions are made as a team"
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $d33928026e868f01$export$2e2bcd8739ae039 = $d33928026e868f01$var$SideBySide;
const $d33928026e868f01$var$ScrollerContent = ({ item: item })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                children: item.title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                children: item.description
            })
        ]
    });
};
const $d33928026e868f01$var$sectionStyle = null;
const $d33928026e868f01$var$scrollerHeading = null;
const $d33928026e868f01$var$heading = null;
const $d33928026e868f01$var$imgStyle = null;

});
parcelRegister("ElG1F", function(module, exports) {
$parcel$export(module.exports, "Scroller", function () { return (parcelRequire("1bVgT")).Scroller; });
parcelRequire("1bVgT");

});
parcelRegister("1bVgT", function(module, exports) {

$parcel$export(module.exports, "ScrollContext", function () { return $570cb559c6297724$export$dece24112a937f92; });
$parcel$export(module.exports, "Scroller", function () { return $570cb559c6297724$export$76d6749d1cf8513c; });
/* scroller.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");

var $b5A0L = parcelRequire("b5A0L");
const $570cb559c6297724$export$dece24112a937f92 = /*#__PURE__*/ (0, $iSvIT.createContext)({
    activeIndex: 0,
    setActiveIndex: ()=>{
        return;
    },
    graphicHeight: 100,
    graphicTopBottom: {
        top: 188,
        bottom: 288
    }
});
const $570cb559c6297724$export$76d6749d1cf8513c = ({ items: items, renderText: renderText, renderGraphic: renderGraphic, heading: heading, layout: layout = "left", mobileGraphicLayout: mobileGraphicLayout = "above", backgroundColor: backgroundColor = "#fff", inScrollBackgroundColor: inScrollBackgroundColor, scrollerInViewOptions: scrollerInViewOptions, navHeight: navHeight = 68 })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)((0, $7Knp0._)({
        threshold: 0.2
    }, scrollerInViewOptions));
    const containerRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    const graphicRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    const headingRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    const [activeIndex, setActiveIndex] = (0, $iSvIT.useState)(0); /**
                                                      * The calculated top position to use for the graphic
                                                      */ 
    const [graphicTop, setGraphicTop] = (0, $iSvIT.useState)(navHeight + 100); /**
                                                                  * The height of the graphic, used to set min height on the text column
                                                                  */ 
    const [graphicHeight, setGraphicHeight] = (0, $iSvIT.useState)(null); /**
                                                                            * The calculated top and bottom positions
                                                                            * to use for determining if an item is aligned with the graphic
                                                                            */ 
    const [graphicTopBottom, setGraphicTopBottom] = (0, $iSvIT.useState)(null);
    (0, $iSvIT.useEffect)(()=>{
        if (!containerRef.current || !graphicRef.current || !headingRef.current || !window) return;
         // Where the magic happens
        const calculateSizes = ()=>{
            var _graphicRef_current, _headingRef_current;
            var _graphicRef_current_clientHeight;
            // Vertically center the graphic +navHeight for the sticky nav
            const currentGraphicHeight = (_graphicRef_current_clientHeight = (_graphicRef_current = graphicRef.current) === null || _graphicRef_current === void 0 ? void 0 : _graphicRef_current.clientHeight) !== null && _graphicRef_current_clientHeight !== void 0 ? _graphicRef_current_clientHeight : 100;
            var _headingRef_current_clientHeight;
            const currentHeaderHeight = (_headingRef_current_clientHeight = (_headingRef_current = headingRef.current) === null || _headingRef_current === void 0 ? void 0 : _headingRef_current.clientHeight) !== null && _headingRef_current_clientHeight !== void 0 ? _headingRef_current_clientHeight : 100;
            const viewHeight = window.innerHeight;
            const minGraphicY = navHeight + currentHeaderHeight;
            const top = (viewHeight - navHeight - currentGraphicHeight) / 2 + navHeight;
            const newTop = Math.max(minGraphicY, top);
            const newBottom = Math.min(viewHeight, newTop + currentGraphicHeight);
            setGraphicTop(Math.max(minGraphicY, top));
            setGraphicHeight(currentGraphicHeight);
            setGraphicTopBottom({
                top: newTop,
                bottom: newBottom
            });
        };
        const observer = new ResizeObserver(()=>{
            // Use requestAnimationFrame to defer DOM updates and prevent ResizeObserver loop limit errors
            // This helps prevent the "ResizeObserver loop limit exceeded" warning by deferring DOM updates
            requestAnimationFrame(()=>{
                calculateSizes();
            });
        });
        observer.observe(containerRef.current);
        return ()=>{
            // Cleanup the observer by unobserving all elements
            observer.disconnect();
        };
    }, [
        containerRef,
        graphicRef,
        headingRef,
        navHeight
    ]);
    const backgroundStyle = null;
    const inViewBackgroundStyle = null;
    const dynamicHeadingStyle = null;
    const inViewHeaderBackgroundStyle = null;
    var _items_activeIndex;
    const currentItem = (_items_activeIndex = items[activeIndex]) !== null && _items_activeIndex !== void 0 ? _items_activeIndex : items[0];
    return /*#__PURE__*/ (0, $loA2J.jsx)($570cb559c6297724$export$dece24112a937f92.Provider, {
        value: {
            activeIndex: activeIndex,
            setActiveIndex: setActiveIndex,
            graphicHeight: graphicHeight,
            graphicTopBottom: graphicTopBottom
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            ref: scrollRef,
            className: (0, $esG4f.default)([
                "_bfhkaxbu",
                sectionIsVisible && "_bfhk1tlu"
            ]),
            style: {
                "--_1ly4823": (0, $43MIc.default)(backgroundColor),
                "--_1p67x28": (0, $43MIc.default)(inScrollBackgroundColor)
            },
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                ref: containerRef,
                className: (0, $esG4f.default)([
                    "_kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _1e0c1txw _2lx2vrvc _18zrzwfg _umua1wqb _owpu1wqb _gltezqdx",
                    "_85i568cl _1q51mgvx _4cvr1y6m _zulp1wqb _10l5idpf _1w2i1bp4",
                    layout === "right" && "_2lx21sbv"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        style: {
                            insetBlockEnd: graphicHeight ? graphicHeight + $570cb559c6297724$var$contentBlockEnd + "px" : "auto"
                        },
                        className: (0, $esG4f.default)([
                            "_kqswstnw _152tidpf _1e02idpf _rjxpidpf _1e0c1txw _1bah1h6o _rolbh2mm"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_16jlkb7n _1o9zkb7n _i0dl1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                ref: headingRef,
                                className: (0, $esG4f.default)([
                                    "_kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _1e0c1txw _2lx2vrvc _18zrzwfg _umua1wqb _owpu1wqb _gltezqdx",
                                    "_152t1gys",
                                    "_1pbykb7n _kqsw1if8 _rolbh2mm _14ucidpf",
                                    sectionIsVisible && "_1itk1qvr"
                                ]),
                                style: {
                                    "--_l57dfm": (0, $43MIc.default)(navHeight ? navHeight + "px" : 0),
                                    "--_1p67x28": (0, $43MIc.default)(inScrollBackgroundColor)
                                },
                                children: heading
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_i0dlhwvj _311g1kc5 _c7541h6o"
                        ]),
                        children: items.map((item, i)=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $b5A0L.ScrollerItem), {
                                index: i,
                                children: [
                                    mobileGraphicLayout === "above" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0cglyw _1yba1ule"
                                        ]),
                                        children: renderGraphic(item, activeIndex, true)
                                    }),
                                    renderText(item),
                                    mobileGraphicLayout === "below" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0cglyw _1yba1ule"
                                        ]),
                                        children: renderGraphic(item, activeIndex, true)
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        ref: graphicRef,
                        style: {
                            insetBlockStart: graphicTop + "px"
                        },
                        className: (0, $esG4f.default)([
                            "_4cvresu3 _1e0c1txw _2lx21bp4 _1bah1h6o _i0dl1nrf _kqsw1if8 _1ybaglyw"
                        ]),
                        children: renderGraphic(currentItem, activeIndex, false)
                    })
                ]
            })
        })
    });
};
const $570cb559c6297724$var$mediaQuery = "@media (max-height: 49.99vw) and (max-width: 1271.99px), (max-height: 635.99px) and (min-width: 1272px), not all and (min-width: 48rem)";
const $570cb559c6297724$var$contentBlockEnd = 120;
const $570cb559c6297724$var$rowStyles = null;
const $570cb559c6297724$var$contentStyle = null;
const $570cb559c6297724$var$headingContainer = null;
const $570cb559c6297724$var$headingColumnContainer = null;
const $570cb559c6297724$var$headingStyle = null;
const $570cb559c6297724$var$rtlRowStyles = null;
const $570cb559c6297724$var$textColumn = null;
const $570cb559c6297724$var$mobileItemStyle = null;
const $570cb559c6297724$var$graphicColumn = null;

});
parcelRegister("b5A0L", function(module, exports) {

$parcel$export(module.exports, "ScrollerItem", function () { return $bfabf9ce9332d9b7$export$11692ab46144d76c; });
/* scroller-item.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $1bVgT = parcelRequire("1bVgT");
const $bfabf9ce9332d9b7$export$11692ab46144d76c = ({ children: children, index: index })=>{
    const { ref: scrollRef, inView: sectionInView } = (0, $eDoPe.useInView)({
        threshold: 0.25
    });
    const itemRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    const { setActiveIndex: setActiveIndex, graphicHeight: graphicHeight, graphicTopBottom: graphicTopBottom } = (0, $iSvIT.useContext)((0, $1bVgT.ScrollContext));
    (0, $iSvIT.useEffect)(()=>{
        if (!document) return;
        const checkElementPosition = ()=>{
            if (!itemRef.current || !graphicTopBottom || !sectionInView) return;
            const rect = itemRef.current.getBoundingClientRect();
            const top = rect.top;
            const bottom = rect.bottom;
            // check if this element overlaps with the top or bottom of the graphic
            if (top >= graphicTopBottom.top && top <= graphicTopBottom.bottom || bottom >= graphicTopBottom.top && bottom <= graphicTopBottom.bottom) setActiveIndex(index);
        };
        document.addEventListener("scroll", checkElementPosition);
        return ()=>{
            document.removeEventListener("scroll", checkElementPosition);
        };
    }, [
        setActiveIndex,
        index,
        itemRef,
        graphicTopBottom,
        sectionInView
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: scrollRef,
        style: {
            minHeight: graphicHeight ? graphicHeight + "px" : "auto"
        },
        className: (0, $esG4f.default)([
            "_kqswh2mm _4t3i1osq _c71l1a8x _1e0c1txw _2lx21bp4 _1bah1h6o _37sk1kxc _19yo1h90 _14q01wqb"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            ref: itemRef,
            className: (0, $esG4f.default)([
                "_1e0c1txw _tzy4kb7n _zulp12am _2lx21bp4"
            ]),
            children: children
        })
    });
};
const $bfabf9ce9332d9b7$var$mediaQuery = "@media (max-height: 49.99vw) and (max-width: 1271.99px), (max-height: 635.99px) and (min-width: 1272px), not all and (min-width: 48rem)";
const $bfabf9ce9332d9b7$var$itemWrapperStyle = null;
const $bfabf9ce9332d9b7$var$itemStyle = null;

});




parcelRegister("9GfN9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6e39944b5408c78$export$2e2bcd8739ae039; });
/* video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $bhreu = parcelRequire("bhreu");
parcelRequire("isSvf");
var $lxS8L = parcelRequire("lxS8L");

var $4XrxY = parcelRequire("4XrxY");
const $f6e39944b5408c78$var$HeroVideo = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _4cvr1h6o _6a6z1h6o _1pfhmgjw _6rthxy5q _1ob9xncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    image: {
                        alt: "",
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/eskxgojb0g32x168w8yg8g7g2586005n.svg"
                    },
                    className: (0, $esG4f.default)([
                        "_t9ec120f _yyhyrgcp _1ii7rgcp _1bsbj6kd"
                    ])
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $lxS8L.Video), {
                    loop: true,
                    muted: true,
                    // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                    videoLink: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-product-discovery/JPD_product-tour_hero.mp4",
                    className: (0, $esG4f.default)([
                        "_1reozryt _18m9zryt _1h1tcq2i _2rko1kwk _kdam1319 _yyhyrgcp _1ii7rgcp _t9eck9uq _14dmvqnv _sfej3ovx"
                    ])
                })
            ]
        })
    });
};
var $f6e39944b5408c78$export$2e2bcd8739ae039 = $f6e39944b5408c78$var$HeroVideo;
const $f6e39944b5408c78$var$container = null;
const $f6e39944b5408c78$var$video = null;
const $f6e39944b5408c78$var$bgImage = null;

});
parcelRegister("isSvf", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return (parcelRequire("lxS8L")).Video; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("lxS8L")).Video; });

var $lxS8L = parcelRequire("lxS8L");

});
parcelRegister("lxS8L", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return $ed253e67f972fd3a$export$ae01dedf5c052bb; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $ed253e67f972fd3a$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return (0, $7Knp0._)({
        maxWidth: "100%"
    }, aspectRatioCSS);
};
const $ed253e67f972fd3a$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $iSvIT.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $iSvIT.useEffect)(()=>{
        var _videoRef_current;
        (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $ed253e67f972fd3a$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});



parcelRegister("8E2OI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $436d75ff88b5caae$export$2e2bcd8739ae039; });
/* workflow.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $bhreu = parcelRequire("bhreu");

var $4XrxY = parcelRequire("4XrxY");
const $436d75ff88b5caae$var$Workflow = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _11q7m7j4 _195g1wug _1rjcoahv _2oz41k92 _1hr2kd3c _ecdxxy5q _6ru51ris"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
            layout: "6-6",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_1mouidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraProductDiscoveryPage.workflow.heading",
                                defaultMessage: "Connect your entire workflow with Jira"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraProductDiscoveryPage.workflow.body.text",
                                defaultMessage: "From strategy and ideation through planning and delivery, bring your entire software lifecycle together in Jira"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1036e8r078n724ru6bb24rdl38bot0iu.webp",
                        alt: ""
                    },
                    className: (0, $esG4f.default)([
                        "_rtys1osq _bna71wug"
                    ])
                })
            ]
        })
    });
};
var $436d75ff88b5caae$export$2e2bcd8739ae039 = $436d75ff88b5caae$var$Workflow;
const $436d75ff88b5caae$var$section = null;
const $436d75ff88b5caae$var$img = null;
const $436d75ff88b5caae$var$bodyContent = null;

});





var $f788Q = parcelRequire("f788Q");

var $6KSFr = parcelRequire("6KSFr");
(0, $f788Q.init)((0, $6KSFr.JiraProductDiscoveryPage));


//# sourceMappingURL=jira-product-discovery-page.225db926.js.map
